import { useCallback } from 'react';
import { useLocation, useMatch, useNavigate, type NavigateOptions } from 'react-router';
import { buildFieldDetailsUrl } from './regional-overview.utils';

export const useRegionalOverviewNavigate = () => {
  const navigate = useNavigate();

  return useCallback(
    (model: string) => ({
      overview: (options?: NavigateOptions) => navigate(`../${model}`, options),
      trapManagement: (path: string, options?: NavigateOptions) => navigate(`../${model}/trap-management/${path}`, options)
    }),
    [navigate]
  );
};

export const useRegionalOverviewFieldNavigate = () => {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const isEmbedded = !!useMatch('/risk-management/:companyId/*');

  return useCallback(
    (orgId: string, propertyId: string, fieldId: string, hasError: boolean) => {
      const url = buildFieldDetailsUrl(orgId, propertyId, fieldId, { hasError, isEmbedded });

      if (isEmbedded) {
        navigate(url, { state: { redirectPath: `${pathname}${search}` } });
        return;
      }

      window.open(url, '_blank');
    },
    [isEmbedded, navigate, pathname, search]
  );
};
